import { NodeSelection, TextSelection, Plugin, PluginKey } from 'prosemirror-state';
import { CommonExtension } from '../../../core/index.js';

/**
 * 数据中是否包含文件
 */ var hasFile = function(items) {
    return items.some(function(item) {
        return item.kind === "file";
    });
};
/**
 * 数据中是否包含 html
 */ var hasHTML = function(items) {
    return items.some(function(item) {
        return item.type === "text/html";
    });
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = window && window.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var WASH_KEY = "getFilter";
/**
 * 从 providers 中获取包含过滤的功能列表
 */ var getFilters = function(providers, view) {
    var filters = new Map();
    _toConsumableArray(providers.entries()).forEach(function(param) {
        var _param = _slicedToArray(param, 2), entryName = _param[0], entryValue = _param[1];
        if (entryValue && entryValue[WASH_KEY] && typeof entryValue[WASH_KEY] === "function") {
            filters.set(entryName, entryValue[WASH_KEY](view));
        }
    });
    return filters;
};
var WashExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(WashExtension, CommonExtension);
    var _super = _createSuper(WashExtension);
    function WashExtension() {
        _classCallCheck(this, WashExtension);
        var _this;
        _this = _super.apply(this, arguments);
        _this.filters = null;
        _this.allCommands = null;
        _this.plugin = function() {
            return new Plugin({
                key: new PluginKey(_this.name),
                props: {
                    handlePaste: function(view, event, slice) {
                        if (!event.clipboardData) return true;
                        var items = Array.from(event.clipboardData.items);
                        return _this.handleDataWash(view, items, slice);
                    },
                    handleDrop: function(view, event, slice, moved) {
                        // moved=true 说明是编辑器中的元素，此时保持编辑器默认行为
                        if (moved) return false;
                        if (!event.dataTransfer) return true;
                        var items = Array.from(event.dataTransfer.items);
                        var dropPos = view.posAtCoords({
                            left: event.clientX,
                            top: event.clientY
                        });
                        return _this.handleDataWash(view, items, slice, dropPos === null || dropPos === void 0 ? void 0 : dropPos.pos);
                    }
                }
            });
        };
        return _this;
    }
    var _proto = WashExtension.prototype;
    _proto.didMountManager = function didMountManager(param) {
        var providers = param.providers, getView = param.getView, commands = param.commands;
        this.filters = getFilters(providers, getView());
        this.allCommands = commands;
    };
    _proto.handleDataWash = function handleDataWash(view, items, slice, dropPos// 拖放的位置
    ) {
        var _this = this;
        if (hasFile(items) && !hasHTML(items)) {
            return true;
        }
        var filters = this.filters;
        var willDelete = new Map();
        // 先对需要清理的节点进行标记
        slice.content.descendants(function(param) {
            var attrs = param.attrs, name = param.type.name;
            if (filters.has(name)) {
                var key = filters.get(name).check(attrs);
                if (key) {
                    if (willDelete.has(key)) {
                        willDelete.get(key).push(name);
                    } else {
                        willDelete.set(key, [
                            name
                        ]);
                    }
                }
            }
        });
        // 记录替换的光标范围
        var replaceFrom = view.state.tr.curSelection.from;
        // 执行内容替换，如果当前是拖放行为，需要替换内容到拖放的位置
        if (dropPos === undefined) {
            view.dispatch(view.state.tr.replaceSelection(slice));
        } else {
            view.dispatch(view.state.tr.replace(dropPos, dropPos, slice));
        }
        var replaceTo = view.state.tr.curSelection.to;
        // 将标记内容进行清理
        _toConsumableArray(willDelete.entries()).forEach(function(param) {
            var _param = _slicedToArray(param, 2), k = _param[0], types = _param[1];
            view.state.doc.content.descendants(function(param, pos) {
                var attrs = param.attrs, name = param.type.name;
                var filter = filters.get(name);
                if (pos < replaceFrom || pos > replaceTo) return true;
                if (filter && types.includes(name) && filter.check(attrs) === k) {
                    var _this_allCommands_name;
                    var tr = view.state.tr;
                    // 当两个附件相连时，删除第一个附件后光标为NodeSelection选中第二个附件，此时handle会导致第二个附件被删除，所以需要重新setSelection
                    view.dispatch(tr.setSelection(NodeSelection.create(view.state.doc, pos)).deleteSelection().setSelection(TextSelection.create(tr.doc, pos)));
                    // 获取数据清洗后的 attrs
                    var handle = filter.handle;
                    var customUpload = function() {
                        var _ref = _asyncToGenerator(function() {
                            var newAttrs;
                            return __generator(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            handle(attrs)
                                        ];
                                    case 1:
                                        newAttrs = _state.sent();
                                        return [
                                            2,
                                            newAttrs
                                        ];
                                }
                            });
                        });
                        return function customUpload() {
                            return _ref.apply(this, arguments);
                        };
                    }();
                    (_this_allCommands_name = _this.allCommands[name]) === null || _this_allCommands_name === void 0 ? void 0 : _this_allCommands_name.insert({
                        customUpload: customUpload,
                        pos: pos
                    });
                    return false;
                }
                return true;
            });
        });
        return true;
    };
    _createClass(WashExtension, [
        {
            key: "name",
            get: function get() {
                return "wash";
            }
        }
    ]);
    return WashExtension;
}(CommonExtension);

export { WashExtension };
//# sourceMappingURL=index.js.map
